import React, { useState, useEffect } from 'react';
import { LoadingScreen } from '../loading/LoadingScreen'
import { getSales, getSalesByTeam, TeamSales } from '../../utils/getData/Sales';
import { Button, Table } from 'react-bootstrap';

const price = process.env.REACT_APP_TICKET_PRICE;
// 売上データが存在する最初の年。年の選択肢はこの年から現在の年まで(降順)
const firstSalesYear = 2023;

const SalesManagement: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [selectedTeam, setSelectedTeam] = useState("");
  const now = new Date();
  const currentYear = now.getFullYear();
  const [year, setYear] = useState(String(currentYear));
  const [month, setMonth] = useState(String(now.getMonth() + 1).padStart(2, '0'));
  const [salesResult, setSalesResult] = useState("");
  // チーム未選択で取得したときのチームごとの販売数
  const [teamSalesList, setTeamSalesList] = useState<TeamSales[]>();
  // 表示中の結果がどの年月のものか(取得後に年月を変えても表示がずれないように取得時に固定する)
  const [resultLabel, setResultLabel] = useState("");
  const [error, setError] = useState("");

  var teamList: Object;
  if (typeof process.env.REACT_APP_TEAMNAMES === "string") {
    teamList = JSON.parse(process.env.REACT_APP_TEAMNAMES);
  } else {
    teamList = [];
  }

  const fetchSalesData = async () => {
    setLoading(true);
    setError("");
    setSalesResult("");
    setTeamSalesList(undefined);
    try {
      const yearMonth = year + month;
      // チーム未選択のときは全チームの売上を一覧で取得する
      if (selectedTeam === "") {
        setTeamSalesList(await getSalesByTeam(yearMonth));
      } else {
        setSalesResult(await getSales(selectedTeam, yearMonth));
      }
      setResultLabel(selectedTeam === "" ? `${year}年 ${month}月` : `${year}年 ${month}月 ${teamDisplayName(selectedTeam)}`);
    } catch {
      setError("データの取得に失敗しました。");
    }
    setLoading(false);
  }

  const teamDisplayName = (teamName: string): string => {
    const name = (teamList as { [key: string]: string })[teamName];
    return name ?? teamName;
  }

  const totalQuantity = teamSalesList?.reduce((sum, sales) => sum + sales.total_quantity, 0) ?? 0;

  useEffect(() => {
    setLoading(false);
  }, []);

  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <div className="mainSection">
      <div className='d-flex justify-content-around'>
        <div>
          <p className='m-0 ms-1'>チーム</p>
          <select className="form-control w-250" name="team" defaultValue={selectedTeam} onChange={e => setSelectedTeam(e.target.value)}>
            <option value=""></option>
            {
              Object.entries(teamList).map(([key, value], index) => (
                <option key={index} value={key}>{value}</option>
              ))
            }
          </select>
        </div>
        <div>
          <p className='m-0 ms-1'>年</p>
          <select className="form-control w-250" name="year" defaultValue={year} onChange={e => setYear(e.target.value)}>
            {
              Array.from({ length: currentYear - firstSalesYear + 1 }, (_, i) => currentYear - i).map(y =>
                <option key={y} value={y}>{y}</option>
              )
            }
          </select>
        </div>
        <div>
          <p className='m-0 ms-1'>月</p>
          <select className="form-control w-250" name="month" defaultValue={month} onChange={e => setMonth(e.target.value)}>
            {
              Array.from({ length: 12 }, (_, i) => i + 1).map(month =>
                <option key={month} value={month < 10 ? `0${month}` : month}>
                  {month < 10 ? `0${month}` : month}
                </option>
              )
            }
          </select>
        </div>
      </div>
      {error !== "" &&
        <div className='text-center text-danger'>{error}</div>
      }
      {salesResult !== "" && (
        // 売上が無い月はバックエンドから "None" が返るため、数値として 0 より大きいときだけ金額を出す
        Number(salesResult) > 0 ?
          <div className='text-center'>{resultLabel} 売上：{(Number(salesResult) * Number(price)).toLocaleString()}円</div> :
          <div className='text-center'>{resultLabel} の売上はありません</div>
      )}
      {teamSalesList !== undefined && (
        teamSalesList.length === 0 ?
          <div className='text-center'>{resultLabel} の売上はありません</div> :
          <div className='my-3'>
            <div className='text-center mb-2'>{resultLabel} チーム別売上</div>
            <Table striped bordered hover className='align-middle'>
              <thead>
                <tr>
                  <th>チーム</th>
                  <th className='text-end'>販売数</th>
                  <th className='text-end'>売上</th>
                </tr>
              </thead>
              <tbody>
                {teamSalesList.map(sales => (
                  <tr key={sales.team_name}>
                    <td>{teamDisplayName(sales.team_name)}</td>
                    <td className='text-end'>{sales.total_quantity.toLocaleString()}</td>
                    <td className='text-end'>{(sales.total_quantity * Number(price)).toLocaleString()}円</td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr className='fw-bold'>
                  <td>合計</td>
                  <td className='text-end'>{totalQuantity.toLocaleString()}</td>
                  <td className='text-end'>{(totalQuantity * Number(price)).toLocaleString()}円</td>
                </tr>
              </tfoot>
            </Table>
          </div>
      )}
      <Button className='mx-auto' onClick={fetchSalesData}>データ取得</Button>
    </div>
  );
};

export default SalesManagement; 